import { QidModel, QidModelFailureMode, QidModelOption, QidModelSafetyFunction } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setQidModelList = (modelList: types.QidModelList) => ({
    type: inferLiteral(types.QID_MODEL_LIST),
    modelList,
})
export const setQidModelIds = (modelIds: readonly number[]) => ({
    type: inferLiteral(types.QID_MODEL_IDS),
    modelIds,
})


export const setQidModelExpandedModelIds = (modelIds: readonly number[]) => ({
    type: inferLiteral(types.QID_MODEL_EXPANDED_MODEL_IDS),
    modelIds,
})
export const setQidModelExpandedSafetyFunctionIds = (safetyFunctionIds: readonly number[]) => ({
    type: inferLiteral(types.QID_MODEL_EXPANDED_SAFETY_FUNCTION_IDS),
    safetyFunctionIds,
})


export const setQidModelSort = (sortColumn: keyof QidModel, sortOrder: OrderType) => ({
    type: inferLiteral(types.QID_MODEL_SORT),
    sortColumn,
    sortOrder,
})
export const setQidModelFilters = (filters: types.QidModelFilters) => ({
    type: inferLiteral(types.QID_MODEL_FILTERS),
    filters,
})


export const setQidModelChangeStatusModel = (model: QidModel) => ({
    type: inferLiteral(types.QID_MODEL_CHANGE_STATUS_MODEL),
    model,
})


export const setQidModelEditModel = (model: QidModel) => ({
    type: inferLiteral(types.QID_MODEL_EDIT_MODEL),
    model,
})
export const setQidModelEditSafetyFunction = (safetyFunction: QidModelSafetyFunction) => ({
    type: inferLiteral(types.QID_MODEL_EDIT_SAFETY_FUNCTION),
    safetyFunction,
})
export const setQidModelEditOption = (option: QidModelOption) => ({
    type: inferLiteral(types.QID_MODEL_EDIT_OPTION),
    option,
})
export const setQidModelEditFailureMode = (failureMode: QidModelFailureMode) => ({
    type: inferLiteral(types.QID_MODEL_EDIT_FAILURE_MODE),
    failureMode,
})


export const setQidModelDeleteModel = (model: QidModel) => ({
    type: inferLiteral(types.QID_MODEL_DELETE_MODEL),
    model,
})
export const setQidModelDeleteSafetyFunction = (safetyFunction: QidModelSafetyFunction) => ({
    type: inferLiteral(types.QID_MODEL_DELETE_SAFETY_FUNCTION),
    safetyFunction,
})
export const setQidModelDeleteOption = (option: QidModelOption) => ({
    type: inferLiteral(types.QID_MODEL_DELETE_OPTION),
    option,
})
export const setQidModelDeleteFailureMode = (failureMode: QidModelFailureMode) => ({
    type: inferLiteral(types.QID_MODEL_DELETE_FAILURE_MODE),
    failureMode,
})


export const setQidModelReloadList = (value: boolean) => ({
    type: inferLiteral(types.QID_MODEL_RELOAD_LIST),
    value,
})
export const setQidModelReloadEditModel = (value: boolean) => ({
    type: inferLiteral(types.QID_MODEL_RELOAD_EDIT_MODEL),
    value,
})
export const setQidModelReloadEditSafetyFunction = (value: boolean) => ({
    type: inferLiteral(types.QID_MODEL_RELOAD_EDIT_SAFETY_FUNCTION),
    value,
})
